import { render, staticRenderFns } from "./ResetModal.vue?vue&type=template&id=defc87fa&scoped=true"
import script from "./ResetModal.vue?vue&type=script&lang=ts"
export * from "./ResetModal.vue?vue&type=script&lang=ts"
import style0 from "./ResetModal.vue?vue&type=style&index=0&id=defc87fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defc87fa",
  null
  
)

export default component.exports